<template>
	<div>
		<router-view name="answerList"></router-view>
	</div>
</template>
<script>

export default {
	name: 'page-answer',
};
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/configuration/page-answer.vue